// extracted by mini-css-extract-plugin
export var wrapper = "immutable-data-module--wrapper--fd-N-";
export var box = "immutable-data-module--box--+t9w5";